export default {
  ENVIRONMENT: process.env.NODE_ENV,
  BASE_URL: process.env.VUE_APP_BASE_URI, // http://{{url}}
  API_URL: process.env.VUE_APP_API_URI, // http://{{url}}/api/
  PDF_URI: process.env.VUE_APP_URI
};
